import { takeEvery, put, call } from 'redux-saga/effects';
import {
    Actions,
    groupDevicesSuccess, groupDevicesFailure,
    disableDeviceSuccess, disableDeviceFailure,
    getDeviceDetailsSuccess, getDeviceDetailsFailure,
    publishDeviceScriptSuccess, publishDeviceScriptFailure,
    deleteDeviceFileSuccess, deleteDeviceFileFailure,
    DeviceDetails,
} from 'actions/deviceActions';
import { DeviceStatus, Device } from 'shared/models';
import { apiGet, apiPut, apiDelete } from './apiSagas';
import { toError } from 'shared/util/toError';


export function* groupDeviceSaga() {
    yield takeEvery(Actions.GROUP_DEVICES_REQUEST, function* groupDevices(action: any) {
        if (!action) {
            return;
        }
        const { buildingId, deviceIds, groupName = 'none' } = action.payload;

        try {
            const devices: Device[] = yield call(apiPut, `/api/buildings/${buildingId}/device-groups/${groupName}`, deviceIds);
            yield put(groupDevicesSuccess({ buildingId, devices }));
        }
        catch (e) {
            const err = toError(e);
            yield put(groupDevicesFailure(err, buildingId));
            return;
        }
    });
}

export function* disableDeviceRequestWatcher() {
    yield takeEvery(Actions.DISABLE_DEVICE_REQUEST, disableDeviceSaga);
}

function* disableDeviceSaga(action: any) {
    const { buildingId, deviceId } = action.payload;
    try {
        yield call(apiPut, `/api/buildings/${buildingId}/devices/${deviceId}/status`, { status: DeviceStatus.Offline });
        yield put(disableDeviceSuccess(buildingId, deviceId));
    }
    catch (e) {
        const err = toError(e);
        yield put(disableDeviceFailure(buildingId, deviceId, err));
    }
}

export function* getDeviceDetailsSaga() {
    yield takeEvery(Actions.GET_DEVICE_DETAILS_REQUEST, function*(action: any) {
        const { buildingId, deviceId } = action.payload;
        try {
            const deviceDetails: DeviceDetails = yield call(apiGet, `/api/buildings/${buildingId}/devices/${deviceId}/admin`);
            yield put(getDeviceDetailsSuccess(buildingId, deviceId, deviceDetails));
        }
        catch (e) {
            const err = toError(e);
            yield put(getDeviceDetailsFailure(buildingId, deviceId, err));
        }
    });
}

export function* publishDeviceScriptSaga() {
    yield takeEvery(Actions.PUBLISH_DEVICE_SCRIPT_REQUEST, function*(action: any) {
        const { buildingId, deviceId, script, scope } = action.payload;
        try {
            yield call(apiPut, `/api/buildings/${buildingId}/devices/${deviceId}/script/${scope}`, script ? JSON.parse(script) : '');
            yield put(publishDeviceScriptSuccess(buildingId, deviceId, script));
        }
        catch (e) {
            const err = toError(e);
            yield put(publishDeviceScriptFailure(buildingId, deviceId, err));
        }
    });
}

export function* deleteDeviceFileSaga() {
    yield takeEvery(Actions.DELETE_DEVICE_FILE_REQUEST, function*(action: any) {
        const { buildingId, deviceId, fileId } = action.payload;
        try {
            yield call(apiDelete, `/api/buildings/${buildingId}/devices/${deviceId}/files/${fileId}`);
            yield put(deleteDeviceFileSuccess(buildingId, deviceId, fileId));
        }
        catch (e) {
            const err = toError(e);
            if (err.message === 'FILE_NOT_FOUND') {
                yield put(deleteDeviceFileSuccess(buildingId, deviceId, fileId));
            }
            else {
                yield put(deleteDeviceFileFailure(buildingId, deviceId, fileId, err));
            }
        }
    });
}
